// Registry for Lab singletons
var LabRegistry = /** @class */ (function () {
    function LabRegistry() {
        this.projectManager = null;
    }
    LabRegistry.getInstance = function () {
        if (LabRegistry._instance === undefined) {
            LabRegistry.create();
        }
        return LabRegistry._instance;
    };
    LabRegistry.create = function () {
        LabRegistry._instance = new LabRegistry();
    };
    LabRegistry.prototype.setProjectManager = function (projectManager) {
        this.projectManager = projectManager;
    };
    LabRegistry.prototype.getProjectManager = function () {
        return this.projectManager;
    };
    return LabRegistry;
}());
export default LabRegistry;
